import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Chính sách bảo mật
        </h1>

        <div className="space-y-6 text-gray-700">
          <section>
            <p className="text-sm text-gray-500 mb-4">
              Cập nhật lần cuối: {new Date().toLocaleDateString('vi-VN')}
            </p>
            <p>
              Chào mừng bạn đến với <strong>Học nhé</strong>. Chúng tôi cam kết bảo vệ quyền riêng tư
              và thông tin cá nhân của bạn khi sử dụng dịch vụ blog của chúng tôi.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              1. Thông tin chúng tôi thu thập
            </h2>
            <p className="mb-2">Khi bạn sử dụng Học nhé, chúng tôi có thể thu thập:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Thông tin tài khoản: email, tên hiển thị, mật khẩu (được mã hóa)</li>
              <li>Nội dung bạn tạo: bài viết, hình ảnh, bình luận</li>
              <li>Thông tin sử dụng: lịch sử truy cập, thời gian sử dụng dịch vụ</li>
              <li>Thông tin kỹ thuật: địa chỉ IP, loại trình duyệt, thiết bị</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              2. Cách chúng tôi sử dụng thông tin
            </h2>
            <p className="mb-2">Thông tin của bạn được sử dụng để:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Cung cấp và cải thiện dịch vụ blog</li>
              <li>Xác thực và bảo mật tài khoản của bạn</li>
              <li>Gửi thông báo quan trọng về dịch vụ</li>
              <li>Phân tích và cải thiện trải nghiệm người dùng</li>
              <li>Ngăn chặn gian lận và lạm dụng dịch vụ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              3. Lưu trữ và bảo mật
            </h2>
            <p>
              Chúng tôi sử dụng các biện pháp bảo mật kỹ thuật và tổ chức để bảo vệ thông tin
              của bạn khỏi truy cập, sử dụng hoặc tiết lộ trái phép. Mật khẩu được mã hóa
              và hình ảnh được lưu trữ an toàn trên Google Drive.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              4. Chia sẻ thông tin
            </h2>
            <p>
              Chúng tôi <strong>không bán</strong> thông tin cá nhân của bạn. Thông tin chỉ được
              chia sẻ trong các trường hợp:
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Với sự đồng ý của bạn</li>
              <li>Để tuân thủ yêu cầu pháp luật</li>
              <li>Với các nhà cung cấp dịch vụ (như Google Drive) để vận hành hệ thống</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              5. Quyền của bạn
            </h2>
            <p className="mb-2">Bạn có quyền:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Truy cập và cập nhật thông tin cá nhân của bạn</li>
              <li>Xóa tài khoản và dữ liệu liên quan</li>
              <li>Xuất dữ liệu của bạn</li>
              <li>Từ chối nhận email marketing (nếu có)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              6. Cookie và công nghệ theo dõi
            </h2>
            <p>
              Chúng tôi sử dụng cookie để duy trì phiên đăng nhập và cải thiện trải nghiệm
              của bạn. Bạn có thể quản lý cookie thông qua cài đặt trình duyệt.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              7. Thay đổi chính sách
            </h2>
            <p>
              Chúng tôi có thể cập nhật chính sách này theo thời gian. Các thay đổi quan trọng
              sẽ được thông báo qua email hoặc thông báo trên trang web.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              8. Liên hệ
            </h2>
            <p>
              Nếu bạn có câu hỏi về chính sách bảo mật, vui lòng liên hệ với chúng tôi qua:
            </p>
            <ul className="list-none space-y-1 ml-4 mt-2">
              <li>Email: <a href="mailto:support@hocnhe.com" className="text-blue-600 hover:underline">support@hocnhe.com</a></li>
              <li>Website: <a href="https://blog.hocnhe.com" className="text-blue-600 hover:underline">https://blog.hocnhe.com</a></li>
            </ul>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 text-center">
              © {new Date().getFullYear()} Học nhé. Tất cả các quyền được bảo lưu.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
